"use client";
import Image from "next/image";

export default function Footer() {
  const logos = [
    "/startups/Artha.png",
    "/startups/Startup_Services.png",
    "/startups/CMA_Report_Services.png",
    "/startups/Registrations.png",
    // "/startups/MCA_(Ministry_of_Corporate_Affairs_).png",
    "/startups/Income_Tax.png",
    "/startups/Entity_Health_Check.png",
    "/startups/Goods_and_Services_Tax.png",
    // "/startups/Financial_Legal_Services.png",
    "/startups/MSME_Services.png",
    "/startups/Business_Tax_Planning_Services.png",
    "/startups/Intellectual_Property_Services.png",
    "/startups/Artha.png",
    "/startups/Startup_Services.png",
    "/startups/CMA_Report_Services.png",
    "/startups/Registrations.png",
    // "/startups/MCA_(Ministry_of_Corporate_Affairs_).png",
    "/startups/Income_Tax.png",
    "/startups/Entity_Health_Check.png",
    "/startups/Goods_and_Services_Tax.png",
    // "/startups/Financial_Legal_Services.png",
    "/startups/MSME_Services.png",
    "/startups/Business_Tax_Planning_Services.png",
    "/startups/Intellectual_Property_Services.png",
    "/startups/Artha.png",
    "/startups/Startup_Services.png",
    "/startups/CMA_Report_Services.png",
    "/startups/Registrations.png",
    // "/startups/MCA_(Ministry_of_Corporate_Affairs_).png",
    "/startups/Income_Tax.png",
    "/startups/Entity_Health_Check.png",
    "/startups/Goods_and_Services_Tax.png",
    // "/startups/Financial_Legal_Services.png",
    "/startups/MSME_Services.png",
    "/startups/Business_Tax_Planning_Services.png",
    "/startups/Intellectual_Property_Services.png",
  ];

  return (
    <section className="w-full flex flex-col items-center px-4 lg:px-8 py-10">
      {/* Heading and Logos Side by Side (wrap on mobile) */}
      <div className="w-full max-w-7xl flex lg:flex-row flex-col justify-between items-center gap-6 md:gap-12 my-4">
        <h2 className="font-[BOOWIE] text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-snug text-center md:text-left font-bold flex-1 min-w-[250px]">
          TRUSTED BY<br /> LEADING STARTUPS!
        </h2>
        {/* <div
          className="
            flex justify-center md:justify-start items-center
            gap-4 sm:gap-6 md:gap-8
            flex-1
            w-full md:w-1/2 overflow-x-auto
            mt-4 md:mt-0
          "
        >
          {logos.map((logo, idx) => (
            <div
              key={idx}
              className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 flex items-center justify-center flex-shrink-0"
            >
              <Image
                src={logo}
                alt={`Logo ${idx + 1}`}
                width={80}
                height={80}
                className="object-contain"
              />
            </div>
          ))}
        </div> */}
        {/* Logo Marquee */}
        <div className="w-full overflow-hidden mt-4 md:mt-0">
          <div className="logo-marquee gap-4 sm:gap-6 md:gap-8">
            {logos.concat(logos).map((logo, idx) => (   // duplicate array once
              <div
                key={idx}
                className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 flex items-center justify-center flex-shrink-0"
              >
                <Image
                  src={logo}
                  alt={`Logo ${idx + 1}`}
                  width={80}
                  height={80}
                  className="object-contain pointer-events-none select-none"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Gold line */}
      <div className="w-1/2 border-b-2 border-[var(--highlight-color)] my-6"></div>

      {/* Scrolling text */}
      {/* <div className="w-full overflow-hidden bg-[var(--scroll-bg)] py-4 rounded-3xl relative">
        <div className="animate-marquee whitespace-nowrap text-lg sm:text-xl md:text-3xl font-bold font-[BOOWIE] text-[var(--primary-text)]">
          RA. MARKETING • RA. MARKETING • RA. MARKETING • RA. MARKETING •
        </div>
      </div> */}
      {/* Scrolling text */}
      <div className="w-full overflow-hidden bg-[var(--scroll-bg)] py-4 rounded-3xl relative">
        <div className="animate-marquee whitespace-nowrap text-lg sm:text-xl md:text-3xl font-bold font-[BOOWIE] text-[var(--primary-text)]">
          <span className="mx-5">EMPOWERING DREAMERS, DOERS, & DECISION-MAKERS • FINANCE • LEGAL • REALTY • MARKETING • BUILDING INDIA TOGETHER  &nbsp;|</span>
          <span className="mx-5">EMPOWERING DREAMERS, DOERS, & DECISION-MAKERS • FINANCE • LEGAL • REALTY • MARKETING • BUILDING INDIA TOGETHER  &nbsp;|</span>
          <span className="mx-5">EMPOWERING DREAMERS, DOERS, & DECISION-MAKERS • FINANCE • LEGAL • REALTY • MARKETING • BUILDING INDIA TOGETHER  &nbsp;|</span>
          <span className="mx-5">EMPOWERING DREAMERS, DOERS, & DECISION-MAKERS • FINANCE • LEGAL • REALTY • MARKETING • BUILDING INDIA TOGETHER  &nbsp;|</span>
        </div>
      </div>


      {/* Copyright */}
      <p className="text-center mt-4 text-xs sm:text-sm text-gray-500">
        © {new Date().getFullYear()} GITARTHA. All rights reserved.
      </p>
    </section>
  );
}
